export default __webpack_public_path__ + "static/sales 3-1b71be6bf9775ee63ba18986083f56d3.png";